import { NavigationTab } from './NavigationTab'
import { Icon, Text } from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { routeToProfile } from '../../../store/selectors/routes'
import { useSelector, useDispatch } from 'react-redux'
import { selectCustomerProfile } from '../../../store/selectors/customerProfile'
import { Link as ReactRouterLink } from 'react-router-dom'
import { NavigationTabProps } from '../../../types/navigation'
import { toggleAuthModal } from '../../../actions/homeSearchAuthModal'
import { selectClientIsGuest } from '../../../store/selectors/client'
import { hasCustomerToken } from '../../../auth'
import { GlobalTrackingEventLocation } from '../../../constants/tracking'

const MSG = defineMessages({
  profile: {
    id: 'NavigationTab.profile',
    defaultMessage: 'Profile'
  }
})

export const ProfileTab = ({ isSelected, ...tabProps }: NavigationTabProps) => {
  const intl = useIntl()
  const dispatch = useDispatch()
  const customerProfile = useSelector(selectCustomerProfile)
  const isGuest = useSelector(selectClientIsGuest)
  const queryParams = new URLSearchParams(location.search)
  const impId = queryParams.get('impId')
  const clientId = queryParams.get('clientId')
  const handleClick = e => {
    if (isGuest && !hasCustomerToken()) {
      e.preventDefault()
      dispatch(toggleAuthModal(true))
      return
    }
  }

  const profileUrl = () => {
    const url = routeToProfile(customerProfile?.id)
    if (impId) {
      return `${url}?impId=${impId}`
    } else if (clientId) {
      return `${url}?clientId=${clientId}`
    }
    return url
  }

  return (
    <NavigationTab
      {...tabProps}
      as={ReactRouterLink}
      to={profileUrl()}
      onClick={handleClick}
      tracking={{
        guid: 'uPJt1bJYz6sjaS9MAF8B6p',
        ui_context: GlobalTrackingEventLocation.GLOBAL_NAVIGATION_BAR,
        descriptor: MSG.profile.defaultMessage
      }}
    >
      <Icon name='single-user'
        marginRight={['0', null, null, '2']}
        marginBottom={['1', null, null, '0']}
      />
      <Text sx={{ textWrap: 'nowrap' }} size={['3xs', 'sm']} m={0} fontWeight='semibold'>
        {intl.formatMessage(MSG.profile)}
      </Text>
    </NavigationTab>
  )
}
